import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  ElementRef,
  OnDestroy,
  ViewChild,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { filter, Observable } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateModule } from '@ngx-translate/core';

import { PrivateNavbarFacade } from '@/app/layouts/private-layout/navbar/private-navbar.facade';
import { PrivateNavbarMenuComponent, PrivateNavbarMenuAction } from '@/app/layouts/private-layout/menu/menu';

@Component({
  selector: 'app-auth-navbar',
  standalone: true,
  imports: [CommonModule, RouterLink, TranslateModule, PrivateNavbarMenuComponent],
  templateUrl: './auth-navbar.html',
  styleUrl: './auth-navbar.scss',
})
export class AuthNavbarComponent implements AfterViewInit, OnDestroy {
  private router = inject(Router);
  private destroyRef = inject(DestroyRef);
  private cdr = inject(ChangeDetectorRef);
  readonly menuFacade = inject(PrivateNavbarFacade);

  @ViewChild('navbarRoot', { static: true }) navbarRoot!: ElementRef<HTMLElement>;

  isLoginPage = true;
  navbarHeightPx = 0;
  readonly menuOpen$: Observable<boolean>;
  private ro?: ResizeObserver;

  constructor() {
    this.menuOpen$ = this.menuFacade.menuOpen$;
    this.syncRoute(this.router.url);

    this.router.events
      .pipe(
        filter((e): e is NavigationEnd => e instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((e) => this.syncRoute(e.urlAfterRedirects));
  }

  ngAfterViewInit(): void {
    const el = this.navbarRoot.nativeElement;

    const update = () => {
      this.navbarHeightPx = el.offsetHeight || 0;
      this.cdr.markForCheck();
    };

    update();

    this.ro = new ResizeObserver(() => update());
    this.ro.observe(el);
  }

  ngOnDestroy(): void {
    this.ro?.disconnect();
  }

  onMenuAction(action: PrivateNavbarMenuAction): void {
    this.menuFacade.handleMenuAction(action);
  }

  private normalizePath(url: string): string {
    return (url ?? '').split('?')[0].split('#')[0];
  }

  private syncRoute(url: string): void {
    const path = this.normalizePath(url);

    const isAuthPublicFlow =
      path === '/auth/login' ||
      path.startsWith('/auth/password-recovery') ||
      path.startsWith('/auth/password-reset');

    const isRegister = path.startsWith('/auth/register');

    this.isLoginPage = isAuthPublicFlow && !isRegister;
  }

}